import React, { useEffect, useState } from 'react';
import { Volume2, Check } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { api } from '../lib/api';
import { SpeakButton } from './SpeakButton';

export const VoicePicker = () => {
  const { t, lang } = useApp();
  const [data, setData] = useState(null);
  const [voice, setVoice] = useState(localStorage.getItem('aurra_voice') || 'nova');

  useEffect(() => { api.voices().then((d) => { setData(d); const saved = localStorage.getItem('aurra_voice'); const known = [...(d.voices || []), ...(d.openai_voices || [])].some((v) => v.id === saved); if ((!saved || !known) && d.default) { setVoice(d.default); localStorage.setItem('aurra_voice', d.default); } }).catch(() => setData({ provider: 'openai', voices: [] })); }, []);

  const pick = (id) => { setVoice(id); localStorage.setItem('aurra_voice', id); };
  const sample = lang === 'fr' ? 'Bonjour, je suis Aurra, votre assistante. Comment puis-je vous aider aujourd\u2019hui ?' : 'Hello, I am Aurra, your assistant. How can I help you today?';

  return (
    <div className="rounded-2xl border border-border bg-card p-6" data-testid="voice-picker">
      <h2 className="font-display font-semibold text-lg flex items-center gap-2"><Volume2 className="h-5 w-5 text-primary" /> {t.account.voiceTitle}</h2>
      <p className="mt-1 text-sm text-muted-foreground">{data?.provider === 'elevenlabs' ? t.account.voiceEleven : t.account.voiceOpenai}</p>
      <div className="mt-4 grid sm:grid-cols-2 gap-2">
        {(data?.voices || []).map((v) => (
          <div key={v.id} data-testid={`voice-option-${v.id}`} className={`flex items-center justify-between gap-2 rounded-xl border px-3 py-2 text-sm cursor-pointer transition-colors ${voice === v.id ? 'border-primary bg-primary/5' : 'border-border hover:bg-accent'}`} onClick={() => pick(v.id)}>
            <span className="flex items-center gap-2 min-w-0">
              <span className={`h-4 w-4 shrink-0 rounded-full border flex items-center justify-center ${voice === v.id ? 'bg-primary border-primary text-primary-foreground' : 'border-border'}`}>{voice === v.id && <Check className="h-3 w-3" />}</span>
              <span className="truncate font-medium">{v.name}</span>
              {v.gender && <span className="text-[10px] text-muted-foreground">{v.gender === 'female' ? '♀' : '♂'}</span>}
              {v.lang && v.lang !== 'multi' && <span className="text-[10px] uppercase text-muted-foreground">{v.lang}</span>}
            </span>
            <span onClick={(e) => e.stopPropagation()}><SpeakButton text={sample} label="" testid={`voice-preview-${v.id}`} voiceOverride={v.id} /></span>
          </div>
        ))}
      </div>
      {data?.openai_voices?.length > 0 && (
        <details className="mt-4">
          <summary className="text-xs text-muted-foreground cursor-pointer" data-testid="openai-voices-toggle">{t.account.voiceOther}</summary>
          <div className="mt-2 flex flex-wrap gap-2">
            {data.openai_voices.map((v) => (
              <button key={v.id} data-testid={`voice-option-${v.id}`} onClick={() => pick(v.id)} className={`px-3 py-1.5 rounded-lg border text-xs ${voice === v.id ? 'border-primary bg-primary/5 font-semibold' : 'border-border hover:bg-accent'}`}>{v.name}</button>
            ))}
          </div>
        </details>
      )}
    </div>
  );
};
